import http from './http'

const profissionalveiculosService = {
  getAllZero: () => http.get(`/profissionalveiculos`).then(result => result.data),
  getAll: page => http.get(`/profissionalveiculoslista?page=${page}`).then(result => result.data),
  getById: id => http.get(`/usuariosprofissionaisgetid/${id}`).then(result => result.data.data),
  getByAll: () => http.get(`/usuariosprofissionaisall`).then(result => result.data),
  delete: id => http.delete(`/profissionalveiculosdelete/${id}`).then(result => result.data.data),
  savePost: data => http({
    method: 'post',
    url: `/profissionalveiculos`,
    data
  }).then(result => result.data.data)
}
export default profissionalveiculosService
